import { render, staticRenderFns } from "./mdBackQueryShSubmitTo.vue?vue&type=template&id=7449747a&scoped=true"
import script from "./mdBackQueryShSubmitTo.vue?vue&type=script&lang=js"
export * from "./mdBackQueryShSubmitTo.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryShSubmitTo.vue?vue&type=style&index=0&id=7449747a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449747a",
  null
  
)

export default component.exports